<ng-container *ngFor="let attribute of visibleAttributes | orderBy: 'id:number'">
  <!-- FORM MODE -->
  <div
    *ngIf="mode === 'form'"
    class="hd-eav-form-field">
    <ng-container [ngSwitch]="attribute.type">
      <ng-container *ngSwitchCase="EavAttributeValueTypeEnum.FILIAL">
        <div class="field">
          <label class="font-medium" [class.required-field]="isRequiredField(attribute)">{{ attribute.name }}</label>
          <ng-container *ngIf="attribute.multipleSelect; else filialSingleForm">
            <crm-filial-multi-select
              [(selectedFilials)]="values[attribute.id]"
              [isFloatLabel]="false"
              [showClear]="true"
              [disabled]="!canEdit"
              appendTo="body"></crm-filial-multi-select>
          </ng-container>
          <ng-template #filialSingleForm>
            <crm-filial-single-select
              [(selectedFilial)]="values[attribute.id]"
              [showClear]="true"
              [disabled]="!canEdit"
              appendTo="body"></crm-filial-single-select>
          </ng-template>
        </div>
      </ng-container>
      <ng-container *ngSwitchCase="EavAttributeValueTypeEnum.COST_CENTER">
        <div class="field">
          <label class="font-medium" [class.required-field]="isRequiredField(attribute)">{{ attribute.name }}</label>
          <ng-container *ngIf="attribute.multipleSelect; else costCenterSingleForm">
            <crm-cost-center-multi-select
              [(selectedCostCenters)]="values[attribute.id]"
              [showClear]="true"
              [disabled]="!canEdit"
              appendTo="body"></crm-cost-center-multi-select>
          </ng-container>
          <ng-template #costCenterSingleForm>
            <crm-cost-center-single-select
              [(selectedCostCenter)]="values[attribute.id]"
              [showClear]="true"
              [disabled]="!canEdit"
              appendTo="body"></crm-cost-center-single-select>
          </ng-template>
        </div>
      </ng-container>
      <ng-container *ngSwitchCase="EavAttributeValueTypeEnum.ROOM">
        <div class="field">
          <label class="font-medium" [class.required-field]="isRequiredField(attribute)">{{ attribute.name }}</label>
          <ng-container *ngIf="attribute.multipleSelect; else roomSingleForm">
            <crm-room-multi-select
              [(selectedRooms)]="values[attribute.id]"
              [showClear]="true"
              [disabled]="!canEdit"
              appendTo="body"></crm-room-multi-select>
          </ng-container>
          <ng-template #roomSingleForm>
            <crm-room-single-select
              [(selectedRoom)]="values[attribute.id]"
              [showClear]="true"
              [disabled]="!canEdit"
              appendTo="body"></crm-room-single-select>
          </ng-template>
        </div>
      </ng-container>
      <ng-container *ngSwitchCase="EavAttributeValueTypeEnum.TEXT">
        <div class="field">
          <label class="font-medium" [class.required-field]="isRequiredField(attribute)">{{ attribute.name }}</label>
          <crm-input-text [(value)]="values[attribute.id]" class="w-full" [disabled]="!canEdit"></crm-input-text>
        </div>
      </ng-container>
      <ng-container *ngSwitchCase="EavAttributeValueTypeEnum.NUMBER">
        <div class="field">
          <label class="font-medium" [class.required-field]="isRequiredField(attribute)">{{ attribute.name }}</label>
          <p-inputNumber [(ngModel)]="values[attribute.id]" [disabled]="!canEdit"></p-inputNumber>
        </div>
      </ng-container>
      <ng-container *ngSwitchCase="EavAttributeValueTypeEnum.COMPUTED">
        <div class="field">
          <label class="font-medium">{{ attribute.name + ' (вычисляется автоматически)' }}</label>
          <p-inputNumber [disabled]="true" [(ngModel)]="values[attribute.id]"></p-inputNumber>
        </div>
      </ng-container>
      <ng-container *ngSwitchCase="EavAttributeValueTypeEnum.DATE">
        <div class="field">
          <label class="font-medium" [class.required-field]="isRequiredField(attribute)">{{ attribute.name }}</label>
          <crm-datepicker [(value)]="values[attribute.id]" [disabled]="!canEdit" appendTo="body"></crm-datepicker>
        </div>
      </ng-container>
      <ng-container *ngSwitchCase="EavAttributeValueTypeEnum.TIMESTAMP">
        <div class="field">
          <label class="font-medium" [class.required-field]="isRequiredField(attribute)">{{ attribute.name }}</label>
          <crm-datepicker
            [(value)]="values[attribute.id]"
            [showTime]="true"
            [stepMinute]="15"
            [disabled]="!canEdit"
            appendTo="body"></crm-datepicker>
        </div>
      </ng-container>
      <ng-container *ngSwitchCase="EavAttributeValueTypeEnum.DATE_PERIOD">
        <div class="field">
          <label class="font-medium" [class.required-field]="isRequiredField(attribute)">{{ attribute.name }}</label>
          <crm-daterangepicker
            *ngIf="canEdit; else datePeriodReadonly"
            [value]="[period.from, period.to]"
            (changeValue)="setDates($event, attribute)"
            appendTo="body"></crm-daterangepicker>
          <ng-template #datePeriodReadonly>
            <p class="m-0">
              <ng-container *ngIf="values[attribute.id]?.from && values[attribute.id]?.to; else noDatePeriod">
                {{ values[attribute.id]?.from | date: 'dd.MM.yyyy' }} - {{ values[attribute.id]?.to | date: 'dd.MM.yyyy' }}
              </ng-container>
              <ng-template #noDatePeriod>Отсутствует</ng-template>
            </p>
          </ng-template>
        </div>
      </ng-container>
      <ng-container *ngSwitchCase="EavAttributeValueTypeEnum.FILES">
        <div class="field">
          <div *ngIf="values[attribute.id]?.length" class="mb-2">
            <crm-files-list
              [files]="values[attribute.id]"
              [canDelete]="canEdit"
              (deleteFile)="deleteFile(values[attribute.id], $event)"></crm-files-list>
          </div>
          <p-fileUpload
            #fileUpload
            mode="basic"
            [customUpload]="true"
            chooseIcon="pi-paperclip"
            [chooseLabel]="attribute.name"
            [disabled]="filesLoading || !canEdit"
            (uploadHandler)="uploadFiles($event, attribute)"
            [auto]="true"></p-fileUpload>
        </div>
      </ng-container>
      <ng-container *ngSwitchCase="EavAttributeValueTypeEnum.BOOLEAN">
        <div class="field-checkbox">
          <p-checkbox
            [(ngModel)]="values[attribute.id]"
            [binary]="true"
            [disabled]="!canEdit"
            [inputId]="'eav-' + attribute.id"></p-checkbox>
          <label [for]="'eav-' + attribute.id">{{ attribute.name }}</label>
        </div>
      </ng-container>
    </ng-container>
    <small
      *ngIf="errors?.eavEntity?.values?.[attribute.id]"
      class="p-error block">
      {{ errors.eavEntity.values[attribute.id] | join }}
    </small>
  </div>

  <!-- CARD MODE -->
  <ng-container
    *ngIf="mode === 'card'"
    [ngSwitch]="attribute.type">
    <ng-container *ngSwitchCase="EavAttributeValueTypeEnum.FILIAL">
        <p-divider styleClass="my-2"></p-divider>
        <ng-container *ngTemplateOutlet="cardField; context: { attribute, type: 'filial' }"></ng-container>
      </ng-container>
      <ng-container *ngSwitchCase="EavAttributeValueTypeEnum.COST_CENTER">
        <p-divider styleClass="my-2"></p-divider>
        <ng-container *ngTemplateOutlet="cardField; context: { attribute, type: 'costCenter' }"></ng-container>
      </ng-container>
      <ng-container *ngSwitchCase="EavAttributeValueTypeEnum.ROOM">
        <p-divider styleClass="my-2"></p-divider>
        <ng-container *ngTemplateOutlet="cardField; context: { attribute, type: 'room' }"></ng-container>
      </ng-container>
      <ng-container *ngSwitchCase="EavAttributeValueTypeEnum.TEXT">
        <p-divider styleClass="my-2"></p-divider>
        <ng-container *ngTemplateOutlet="cardField; context: { attribute, type: 'text' }"></ng-container>
      </ng-container>
      <ng-container *ngSwitchCase="EavAttributeValueTypeEnum.NUMBER">
        <p-divider styleClass="my-2"></p-divider>
        <ng-container *ngTemplateOutlet="cardField; context: { attribute, type: 'number' }"></ng-container>
      </ng-container>
      <ng-container *ngSwitchCase="EavAttributeValueTypeEnum.COMPUTED">
        <p-divider styleClass="my-2"></p-divider>
        <div class="grid hd-eav-card-row align-items-center m-0">
          <div class="col-4 font-medium">{{ attribute.name }}</div>
          <div class="col-8 flex justify-content-end">{{ values[attribute.id] ?? 'Отсутствует' }}</div>
        </div>
      </ng-container>
      <ng-container *ngSwitchCase="EavAttributeValueTypeEnum.DATE">
        <p-divider styleClass="my-2"></p-divider>
        <ng-container *ngTemplateOutlet="cardField; context: { attribute, type: 'date' }"></ng-container>
      </ng-container>
      <ng-container *ngSwitchCase="EavAttributeValueTypeEnum.TIMESTAMP">
        <p-divider styleClass="my-2"></p-divider>
        <ng-container *ngTemplateOutlet="cardField; context: { attribute, type: 'timestamp' }"></ng-container>
      </ng-container>
      <ng-container *ngSwitchCase="EavAttributeValueTypeEnum.DATE_PERIOD">
        <p-divider styleClass="my-2"></p-divider>
        <ng-container *ngTemplateOutlet="cardField; context: { attribute, type: 'datePeriod' }"></ng-container>
      </ng-container>
      <ng-container *ngSwitchCase="EavAttributeValueTypeEnum.FILES">
        <p-divider styleClass="my-2"></p-divider>
        <div class="grid hd-eav-card-row align-items-center m-0">
          <div class="col-4 font-medium">{{ attribute.name }}</div>
          <div class="col-8 flex justify-content-end flex-wrap">
            <ng-container *ngIf="isAttributeMutationLoading(attribute.id); else filesCardValue">
              <crm-card-inline-mutation-skeleton-v2></crm-card-inline-mutation-skeleton-v2>
            </ng-container>
            <ng-template #filesCardValue>
            <ng-container *ngIf="canEdit; else filesReadonly">
              <crm-change-field-in-card #filesField [enabledMenu]="false" (onClickExternal)="emitFieldSave(attribute.id)">
                <ng-template #infoTemplate>
                  <ng-container *ngIf="values[attribute.id]?.length; else notFiles">
                    <crm-files-list [files]="values[attribute.id]" [canDelete]="false"></crm-files-list>
                  </ng-container>
                  <ng-template #notFiles>Нет файлов</ng-template>
                </ng-template>
                <ng-template #editTemplate>
                  <div class="w-full">
                    <crm-files-list
                      *ngIf="values[attribute.id]?.length"
                      [files]="values[attribute.id]"
                      [canDelete]="true"
                      (deleteFile)="deleteFile(values[attribute.id], $event)"></crm-files-list>
                    <p-fileUpload
                      mode="basic"
                      [customUpload]="true"
                      chooseIcon="pi-paperclip"
                      [chooseLabel]="attribute.name"
                      [disabled]="filesLoading"
                      (uploadHandler)="uploadFiles($event, attribute); filesField.closeEditPanel()"
                      [auto]="true"></p-fileUpload>
                  </div>
                </ng-template>
              </crm-change-field-in-card>
            </ng-container>
            <ng-template #filesReadonly>
              <ng-container *ngIf="values[attribute.id]?.length; else notFilesReadonly">
                <div
                  *ngFor="let file of values[attribute.id] | orderBy: '-created:date'; last as isLast"
                  class="flex align-items-center mr-2 mb-1">
                  <crm-document-link *ngIf="toFile(file) as f" [file]="f" [isShowFileSize]="false"></crm-document-link>
                  {{ isLast ? '' : '; ' }}
                </div>
              </ng-container>
              <ng-template #notFilesReadonly>Нет файлов</ng-template>
            </ng-template>
            </ng-template>
          </div>
        </div>
      </ng-container>
      <ng-container *ngSwitchCase="EavAttributeValueTypeEnum.BOOLEAN">
        <p-divider styleClass="my-2"></p-divider>
        <div class="grid hd-eav-card-row align-items-center m-0">
          <div class="col-4 font-medium">{{ attribute.name }}</div>
          <div class="col-8 flex justify-content-end">
            <ng-container *ngIf="isAttributeMutationLoading(attribute.id); else booleanCardValue">
              <crm-card-inline-mutation-skeleton-v2 variant="checkbox"></crm-card-inline-mutation-skeleton-v2>
            </ng-container>
            <ng-template #booleanCardValue>
            <ng-container *ngIf="canEdit; else booleanReadonly">
              <crm-change-field-in-card #boolField [enabledMenu]="false" (onClickExternal)="emitFieldSave(attribute.id)">
                <ng-template #infoTemplate>{{ values[attribute.id] ? 'Да' : 'Нет' }}</ng-template>
                <ng-template #editTemplate>
                  <p-checkbox
                    [(ngModel)]="values[attribute.id]"
                    [binary]="true"
                    (onChange)="boolField.closeEditPanel()"></p-checkbox>
                </ng-template>
              </crm-change-field-in-card>
            </ng-container>
            <ng-template #booleanReadonly>{{ values[attribute.id] ? 'Да' : 'Нет' }}</ng-template>
            </ng-template>
          </div>
        </div>
      </ng-container>
  </ng-container>
</ng-container>

<ng-template #cardField let-attribute="attribute" let-type="type">
  <div class="grid hd-eav-card-row align-items-center m-0">
    <div class="col-4 font-medium">{{ attribute.name }}</div>
    <div class="col-8 flex justify-content-end">
      <ng-container *ngIf="isAttributeMutationLoading(attribute.id); else cardFieldValue">
        <crm-card-inline-mutation-skeleton-v2></crm-card-inline-mutation-skeleton-v2>
      </ng-container>
      <ng-template #cardFieldValue>
      <ng-container *ngIf="canEdit; else cardReadonly">
        <crm-change-field-in-card
          #cardFieldRef
          [enabledMenu]="false"
          (onClickExternal)="emitFieldSave(attribute.id)">
          <ng-template #infoTemplate>
            <ng-container [ngSwitch]="type">
              <ng-container *ngSwitchCase="'filial'">
                {{
                  attribute.multipleSelect
                    ? values[attribute.id]?.length
                      ? (values[attribute.id] | join: 'name')
                      : 'Отсутствует'
                    : values[attribute.id]?.name ?? 'Отсутствует'
                }}
              </ng-container>
              <ng-container *ngSwitchCase="'costCenter'">
                {{
                  attribute.multipleSelect
                    ? values[attribute.id]?.length
                      ? (values[attribute.id] | join: 'name')
                      : 'Отсутствует'
                    : values[attribute.id]?.name ?? 'Отсутствует'
                }}
              </ng-container>
              <ng-container *ngSwitchCase="'room'">
                {{
                  attribute.multipleSelect
                    ? values[attribute.id]?.length
                      ? (values[attribute.id] | join: 'name')
                      : 'Отсутствует'
                    : values[attribute.id]?.name ?? 'Отсутствует'
                }}
              </ng-container>
              <ng-container *ngSwitchCase="'text'">{{ values[attribute.id] ?? 'Отсутствует' }}</ng-container>
              <ng-container *ngSwitchCase="'number'">{{ values[attribute.id] ?? 'Отсутствует' }}</ng-container>
              <ng-container *ngSwitchCase="'date'">
                <ng-container *ngIf="values[attribute.id]; else noDate">{{ values[attribute.id] | date: 'dd.MM.yyyy' }}</ng-container>
                <ng-template #noDate>Отсутствует</ng-template>
              </ng-container>
              <ng-container *ngSwitchCase="'timestamp'">
                <ng-container *ngIf="values[attribute.id]; else noTs">{{ values[attribute.id] | date: 'dd.MM.yyyy HH:mm' }}</ng-container>
                <ng-template #noTs>Отсутствует</ng-template>
              </ng-container>
              <ng-container *ngSwitchCase="'datePeriod'">
                <ng-container
                  *ngIf="values[attribute.id]?.from && values[attribute.id]?.to; else noPeriod">
                  {{ values[attribute.id]?.from | date: 'dd.MM.yyyy' }} - {{ values[attribute.id]?.to | date: 'dd.MM.yyyy' }}
                </ng-container>
                <ng-template #noPeriod>Отсутствует</ng-template>
              </ng-container>
            </ng-container>
          </ng-template>
          <ng-template #editTemplate>
            <ng-container [ngSwitch]="type">
              <ng-container *ngSwitchCase="'filial'">
                <crm-filial-multi-select
                  *ngIf="attribute.multipleSelect; else filialCardSingle"
                  [(selectedFilials)]="values[attribute.id]"
                  (selectedFilialsChange)="cardFieldRef.closeEditPanel()"
                  styleClass="hd-eav-card-select w-20rem"
                  class="hd-eav-card-select w-20rem"></crm-filial-multi-select>
                <ng-template #filialCardSingle>
                  <crm-filial-single-select
                    [(selectedFilial)]="values[attribute.id]"
                    (selectedFilialChange)="cardFieldRef.closeEditPanel()"
                    [showClear]="true"
                    styleClass="hd-eav-card-select w-20rem"
                    class="hd-eav-card-select w-20rem"></crm-filial-single-select>
                </ng-template>
              </ng-container>
              <ng-container *ngSwitchCase="'costCenter'">
                <crm-cost-center-multi-select
                  *ngIf="attribute.multipleSelect; else ccCardSingle"
                  [(selectedCostCenters)]="values[attribute.id]"
                  (selectedCostCentersChange)="cardFieldRef.closeEditPanel()"
                  styleClass="hd-eav-card-select w-20rem"
                  class="hd-eav-card-select w-20rem"></crm-cost-center-multi-select>
                <ng-template #ccCardSingle>
                  <crm-cost-center-single-select
                    [(selectedCostCenter)]="values[attribute.id]"
                    (selectedCostCenterChange)="cardFieldRef.closeEditPanel()"
                    [showClear]="true"
                    styleClass="hd-eav-card-select w-20rem"
                    class="hd-eav-card-select w-20rem"></crm-cost-center-single-select>
                </ng-template>
              </ng-container>
              <ng-container *ngSwitchCase="'room'">
                <crm-room-multi-select
                  *ngIf="attribute.multipleSelect; else roomCardSingle"
                  [(selectedRooms)]="values[attribute.id]"
                  (selectedRoomsChange)="cardFieldRef.closeEditPanel()"
                  styleClass="hd-eav-card-select w-20rem"
                  class="hd-eav-card-select w-20rem"></crm-room-multi-select>
                <ng-template #roomCardSingle>
                  <crm-room-single-select
                    [(selectedRoom)]="values[attribute.id]"
                    (selectedRoomChange)="cardFieldRef.closeEditPanel()"
                    [showClear]="true"
                    styleClass="hd-eav-card-select w-20rem"
                    class="hd-eav-card-select w-20rem"></crm-room-single-select>
                </ng-template>
              </ng-container>
              <ng-container *ngSwitchCase="'text'">
                <crm-input-text
                  [(value)]="values[attribute.id]"
                  (keydown.enter)="cardFieldRef.closeEditPanel()"></crm-input-text>
              </ng-container>
              <ng-container *ngSwitchCase="'number'">
                <p-inputNumber
                  [(ngModel)]="values[attribute.id]"
                  (keydown.enter)="cardFieldRef.closeEditPanel()"></p-inputNumber>
              </ng-container>
              <ng-container *ngSwitchCase="'date'">
                <crm-datepicker
                  [(value)]="values[attribute.id]"
                  (valueChange)="cardFieldRef.closeEditPanel()"
                  [isNotCheckedExternal]="true"></crm-datepicker>
              </ng-container>
              <ng-container *ngSwitchCase="'timestamp'">
                <crm-datepicker
                  [(value)]="values[attribute.id]"
                  (valueChange)="cardFieldRef.closeEditPanel()"
                  [isNotCheckedExternal]="true"
                  [stepMinute]="15"
                  [showTime]="true"></crm-datepicker>
              </ng-container>
              <ng-container *ngSwitchCase="'datePeriod'">
                <crm-daterangepicker
                  [value]="[period.from, period.to]"
                  (changeValue)="setDates($event, attribute); cardFieldRef.closeEditPanel()"></crm-daterangepicker>
              </ng-container>
            </ng-container>
          </ng-template>
        </crm-change-field-in-card>
      </ng-container>
      <ng-template #cardReadonly>
        <ng-container [ngSwitch]="type">
          <ng-container *ngSwitchCase="'filial'">
            {{
              attribute.multipleSelect
                ? values[attribute.id]?.length
                  ? (values[attribute.id] | join: 'name')
                  : 'Отсутствует'
                : values[attribute.id]?.name ?? 'Отсутствует'
            }}
          </ng-container>
          <ng-container *ngSwitchCase="'costCenter'">
            {{
              attribute.multipleSelect
                ? values[attribute.id]?.length
                  ? (values[attribute.id] | join: 'name')
                  : 'Отсутствует'
                : values[attribute.id]?.name ?? 'Отсутствует'
            }}
          </ng-container>
          <ng-container *ngSwitchCase="'room'">
            {{
              attribute.multipleSelect
                ? values[attribute.id]?.length
                  ? (values[attribute.id] | join: 'name')
                  : 'Отсутствует'
                : values[attribute.id]?.name ?? 'Отсутствует'
            }}
          </ng-container>
          <ng-container *ngSwitchDefault>{{ values[attribute.id] ?? 'Отсутствует' }}</ng-container>
        </ng-container>
      </ng-template>
      </ng-template>
    </div>
  </div>
</ng-template>
